import { Content } from '@visikon/core-models';
import { Translation } from '@visikon/core-models/languageTypes';
import { Dialog, DialogAnimations, DialogBody, DialogHeader } from '@visikon/spine';
import { DocumentRenderer } from '../../components/documentViewer/DocumentRenderer';
import { i18N } from '../../internationalization/AppText';
import { MarkdownRenderer } from './MarkdownRenderer';

type Props = {
  dialogRef: React.RefObject<HTMLDialogElement>;
  document: Translation<Content.Text>;
  markdown?: string | undefined;
};

export const ContactDialog = ({ dialogRef, document, markdown }: Props) => {
  return (
    <Dialog className={DialogAnimations.SlideDown} _ref={dialogRef}>
      <DialogHeader>{i18N('contact')}</DialogHeader>
      <DialogBody>
        {markdown ? (
          <MarkdownRenderer content={markdown} />
        ) : (
          <DocumentRenderer document={(document!.content as any).document} style={{ padding: 'unset' }} />
        )}
      </DialogBody>
    </Dialog>
  );
};
